module.exports = __webpack_public_path__ + "media/images/theshrinelogo-21d2411a3178027a5597827b66146cc1.png";